import React, { useState, useRef, useEffect } from 'react';
import { API_BASE_URL } from '../config';

const SLUGS = [
  { slug: 'falstaff', label: 'Falstaff' },
  { slug: 'lady_macbeth', label: 'Lady Macbeth' },
  { slug: 'iago', label: 'Iago' },
  { slug: 'miranda', label: 'Miranda' },
  { slug: 'sir_andrew', label: 'Sir Andrew' },
];

export default function CharacterChat() {
  const [slug, setSlug] = useState(SLUGS[0].slug);
  const [label, setLabel] = useState(SLUGS[0].label);
  const [avatars, setAvatars] = useState({});
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const endRef = useRef(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const r = await fetch(`${API_BASE_URL}/api/ui/chat/avatars`);
        const dj = await r.json();
        if (alive) setAvatars(dj || {});
      } catch {}
    })();
    return () => { alive = false };
  }, []);

  useEffect(() => {
    if (endRef.current) endRef.current.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const onSelect = (e) => {
    const val = e.target.value;
    setSlug(val);
    const found = SLUGS.find(s => s.slug === val);
    setLabel(found ? found.label : val);
    setMessages([]);
  };

  const send = async () => {
    const text = input.trim();
    if (!text) return;
    setMessages(prev => [...prev, { who: 'you', text }]);
    setInput('');
    try {
      const r = await fetch(`${API_BASE_URL}/api/ui/chat/${slug}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: text })
      });
      const dj = await r.json();
      const reply = (dj && dj.reply) || '(no reply)';
      setMessages(prev => [...prev, { who: 'them', text: reply }]);
    } catch (e) {
      setMessages(prev => [...prev, { who: 'them', text: '(failed to send)' }]);
    }
  };

  const onKey = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      send();
    }
  };

  const avatarFor = (lbl) => {
    const key = (lbl || '').toLowerCase();
    return avatars[key] || '';
  };

  return (
    <div className="console-container">
      <div className="console-left" style={{ width: '100%' }}>
        <div className="console-panel chat-console">
          <div className="chat-header">
            <select value={slug} onChange={onSelect} className="chat-select">
              {SLUGS.map(s => (
                <option key={s.slug} value={s.slug}>{s.label}</option>
              ))}
            </select>
            <div className="chat-title">
              <span className="avatar lg" style={{ backgroundImage: `url(${avatarFor(label)})` }} />
              <span className="chat-name">{label}</span>
            </div>
          </div>
          <div className="chat-body">
            {messages.map((m, i) => (
              <div key={i} className={`chat-line ${m.who==='you'?'user':'char'}`}>
                {m.who==='you' ? (<>
                  <strong className="user-name">&lt;user&gt;:</strong> <span className="user-text">{m.text}</span>
                </>) : (
                  <>
                    <span className="avatar sm" style={{ backgroundImage: `url(${avatarFor(label)})` }} />
                    <strong className="char-name">{label}:</strong> <span className="char-text">{m.text}</span>
                  </>
                )}
              </div>
            ))}
            <div ref={endRef} />
          </div>
          <div className="chat-input">
            <textarea rows={3} value={input} onChange={e=>setInput(e.target.value)} onKeyDown={onKey} placeholder={`Address ${label}…`} />
            <button onClick={send}>Send</button>
          </div>
        </div>
      </div>
    </div>
  );
}
